export const SET_DELIVERYNOTES = 'SET_DELIVERYNOTES'
export const SET_TOTAL_DELIVERYNOTES = 'SET_TOTAL_DELIVERYNOTES'
export const RESET_SELECTED_DELIVERYNOTES = 'RESET_SELECTED_DELIVERYNOTES'
export const SET_SELECTED_DELIVERYNOTES = 'SET_SELECTED_DELIVERYNOTES'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const SET_TEMPLATE_ID = 'SET_TEMPLATE_ID' 
export const SELECT_CUSTOMER = 'SELECT_CUSTOMER'
export const RESET_SELECTED_CUSTOMER = 'RESET_SELECTED_CUSTOMER'
export const DELETE_DELIVERY_NOTE = 'DELETE_DELIVERY_NOTE'

export const SET_DELIVERYNOTE_ITEMS = 'SET_DELIVERYNOTE_ITEMS'
export const RESET_SELECTED_DELIVERYNOTE_ITEMS = 'RESET_SELECTED_DELIVERYNOTE_ITEMS'
export const SET_SELECTED_DELIVERYNOTE_ITEMS = 'SET_SELECTED_DELIVERYNOTE_ITEMS'
export const SET_SELECT_ALL_STATE_ITEM = 'SET_SELECT_ALL_STATE_ITEM'
export const DELETE_DELIVERY_NOTE_ITEM = 'DELETE_DELIVERY_NOTE_ITEM'
export const DELETE_DELIVERY_NOTE_MULTIPLE_ITEMS = 'DELETE_DELIVERY_NOTE_MULTIPLE_ITEMS'
export const ADD_DELIVERY_NOTE_ITEMS = 'ADD_DELIVERY_NOTE_ITEMS'
export const UPDATE_DELIVERY_NOTE_ITEM = 'UPDATE_DELIVERY_NOTE_ITEM'
export const SET_PO_ITEM = 'SET_PO_ITEM'
export const DELETE_PO_ITEM = 'DELETE_PO_ITEM'

export const AVAILABLE_DELIVERYNOTE_ITEMS = 'AVAILABLE_DELIVERYNOTE_ITEMS'
export const TEMP_MULTIPLE_DELETE_ITEMS = 'TEMP_MULTIPLE_DELETE_ITEMS'
export const TEMP_DELETE_ITEM = 'TEMP_DELETE_ITEM'
export const TEMP_ADD_ITEM = 'TEMP_ADD_ITEM'
export const SET_DELIVERYNOTE_ITEMS_STATUS = 'SET_DELIVERYNOTE_ITEMS_STATUS'

export const PO_HAS_ITEM = 'PO_HAS_ITEM'
